<template>
  <div class="">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
          <el-form-item label="运单编号:" class="item1">
            <el-input  placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNos" ></el-input>
          </el-form-item>
          <el-form-item label="创建时间:" class="item2">
            <el-date-picker
              v-model="createTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="签收时间:" class="item2">
            <el-date-picker
              v-model="actualSignings"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="付款部门:" prop="payee">
             <el-input v-model="searchFrom.payee" placeholder="请输入付款部门"></el-input>
          </el-form-item>
          <el-form-item label="结算方式:">
            <el-select v-model="searchFrom.incomePattern" clearable placeholder="请选择">
              <el-option v-for="item in incomeList" :key="item.id" :label="item.showName" :value="item.itemNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态:">
            <el-select v-model="searchFrom.ysSettlementStates" placeholder="请选择结算状态">
              <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="运单号:" prop="businessNo">
            <el-input v-model="searchFrom.wayNo" placeholder="请输入运单号"></el-input>
          </el-form-item> -->
          <el-form-item label="货物类型:">
            <el-select v-model="searchFrom.productTypeName" placeholder="请选择货物类型">
              <el-option  label="全部" value="" ></el-option>
              <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运单状态:">
            <el-select v-model="searchFrom.wayState" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option label="待配载" value="0" ></el-option>
              <el-option label="待装车" value="1" ></el-option>
              <el-option label="运输中" value="2" ></el-option>
              <el-option label="待签收" value="3" ></el-option>
              <el-option label="已签收" value="4" ></el-option>
              <el-option label="已作废" value="5" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签收人:" prop="actualSigningPerson">
            <el-input v-model="searchFrom.actualSigningPerson" placeholder="请输入签收人"></el-input>
          </el-form-item>
        </div>
        <div style="">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
            <el-button type="primary" size="mini" :disabled="isDisable" @click="daochuFN">导出</el-button>
            <el-button type="primary" size="mini" @click="duizhang" v-if="btnFlg[0]">对账</el-button>
          </el-form-item>
          <span>
            <el-form-item>
              <p class="margin0">收入总额合计：<span class="red">{{map.grossRevenueSum}}</span>元</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0">已选：<span class="red">{{duiZhangData.wayNumber}}</span>个运单</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0">收入总额<span class="red">{{duiZhangData.totalAmount}}</span>元</p>
            </el-form-item>
          </span>
        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tabref"  highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}"  class="tableComent"
      @selection-change='selectGoods'
      >
        <el-table-column type="selection" width="50" fixed></el-table-column>
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
        <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
        <el-table-column prop="incomePatternName" label="结算方式" width="100" :formatter="formatterRowEmpty">
          <!-- <template scope="scope">
            <span v-show="scope.row.incomePattern == '0'">月结</span>
            <span v-show="scope.row.incomePattern == '1'">现结</span>
          </template> -->
        </el-table-column>
        <el-table-column property="" width="100" label="运单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.wayState==0">待配载</span>
            <span v-else-if="scope.row.wayState==1">待装车</span>
            <span style="color: #E99D42;" v-else-if="scope.row.wayState==2" >运输中</span>
            <span style="color: #D51212;" v-else-if="scope.row.wayState==3" >待签收</span>
            <span style="color: #81B337;" v-else-if="scope.row.wayState==4" >已签收</span>
            <span style="color: #9A9A9A;" v-else-if="scope.row.wayState==5" >已作废</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="结算状态" width="100">
          <template scope="scope">
            <span class="wsStyle" v-show="scope.row.ysSettlementStates == '-1'">未对账</span>
            <span class="wsStyle" v-show="scope.row.ysSettlementStates == '0'">未确认</span>
            <span class="ysStyle" v-show="scope.row.ysSettlementStates == '2'">已确认</span>
          </template>
        </el-table-column>
        <el-table-column prop="payee" label="付款部门" width="230" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" width="100">
        </el-table-column>
        <el-table-column prop="liquidatedAmountName" label="结算量" width="100" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="revenueValuationName" label="收入计价" width="100" :formatter="formatterRowEmpty">
          <!-- <template scope="scope">
            0.按吨、1.按车、2.按方、3.按件
            <span v-show="scope.row.revenueValuation == '0'">按吨</span>
            <span v-show="scope.row.revenueValuation == '1'">按车</span>
            <span v-show="scope.row.revenueValuation == '2'">按方</span>
            <span v-show="scope.row.revenueValuation == '3'">按件</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="" label="收入单价" width="130">
          <template scope="scope">
            <div>
              <span v-if="scope.row.revenueValuation == '0'">{{scope.row.incomeUnitPrice}}元/吨</span>
              <span v-if="scope.row.revenueValuation == '1'">
                <span v-if="scope.row.incomeUnitPrice != 0">{{scope.row.incomeUnitPrice}}元/车</span>
                <span v-else>-</span>
              </span>
              <span v-if="scope.row.revenueValuation == '2'">{{scope.row.incomeUnitPrice}}元/方</span>
              <span v-if="scope.row.revenueValuation == '3'">{{scope.row.incomeUnitPrice}}元/件</span>
              <span v-if="scope.row.revenueValuation == '' || scope.row.revenueValuation == null">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="incomeAmount" label="收入金额(元)" width="130" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="revenueSurcharge" label="收入附加费(元)" width="130" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="incomeRemark" label="收入备注" width="130" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="grossRevenue" label="收入总额(元)" width="130" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="generalCarrier" label="承运方" width="200" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" width="120" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="driverName" label="司机姓名" width="120" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="driverPhone" label="司机电话" width="120" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="180"></el-table-column>
        <el-table-column prop="actualSigningPerson" label="签收人" width="120" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="180"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 对账弹框 -->
    <duizhangMark v-if="duizhangMark" :duizhangMark.sync='duizhangMark' :duiZhangData = 'duiZhangData' :YSFlag='1' @refresh = 'chaxun'></duizhangMark>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { getCurrUserDepartment } from '@/api/newCrm'
import { findWayBusinessList, getDictionaryDetailList, findWayBusinessListTotal } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import duizhangMark from '@/views/newTMS/publicFiles/duiZhangDialog.vue'
export default {
  name: 'Freight',
  components: {
    duizhangMark
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      detailsMark: false,
      loading: false,
      duizhangMark: false,
      incomeList: [],
      ysSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未对账',
          value: '-1'
        },
        {
          showName: '未确认',
          value: '0'
        },
        {
          showName: '已确认',
          value: '2'
        }
      ],
      HWlist: [],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTimes: [],
      actualSignings: [],
      searchFrom: {
        payeeType: '0',
        ysSettlementStates: '-1',
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00L0100'],
      tableList: [],
      bumenList: [],
      map: {
        grossRevenueSum: 0
      },
      duiZhangData: {
        wayNumber: 0, // 运单数量
        totalAmount: 0, // 选中的应收总额
        insideOutsideType: '0',
        makeTicketYn: '',
        settlementPattern: ''
      },
      ids: [],
      isDisable: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/YScalculate')
    this.createTimes = getLastMonth()
    this.getList()
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getCurrUserDepartment().then(res => { this.bumenList = res })
    getDictionaryDetailList({ dictionaryType: 'up_settlement_type' }).then(res => { this.incomeList = res })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 200 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      if (this.createTimes) {
        this.$set(this.searchFrom, 'createTimeStart', this.createTimes[0])
        this.$set(this.searchFrom, 'createTimeEnd', this.createTimes[1])
      } else {
        this.$set(this.searchFrom, 'createTimeStart', '')
        this.$set(this.searchFrom, 'createTimeEnd', '')
      }
      if (this.actualSignings) {
        this.$set(this.searchFrom, 'actualSigningTimeStart', this.actualSignings[0])
        this.$set(this.searchFrom, 'actualSigningTimeEnd', this.actualSignings[1])
      } else {
        this.$set(this.searchFrom, 'actualSigningTimeStart', '')
        this.$set(this.searchFrom, 'actualSigningTimeEnd', '')
      }
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNo = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNo.split(',')
      } else {
        this.$set(this.searchFrom, 'wayNos', '')
        this.searchFrom.wayNoList = null
      }
      findWayBusinessList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      findWayBusinessListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 选择数据
    selectGoods (selection) {
      this.duiZhangData.wayNumber = 0
      console.log(selection, 'selection')
      this.duiZhangData.totalAmount = 0.00
      this.ids = []
      selection.forEach((item, index) => {
        this.duiZhangData.totalAmount += item.grossRevenue
        this.duiZhangData.wayNumber = index + 1
        this.ids.push(item.id)
      })
      this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        payeeType: '0',
        ysSettlementStates: '-1',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: '',
        wayNoList: null
      }
      // this.createTimes = []
      this.createTimes = getLastMonth()
      this.actualSignings = []
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    duizhang () {
      let selectData = this.$refs.tabref.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flagA = selectData.every(item => item.ysSettlementStates == '-1')
        let flagC = selectData.some(item => item.actualSigningTime == null)
        if (!flagA) {
          this.$alert('只能选择未对账的数据', '系统提示')
        } else if (flagC) {
          this.$alert('存在未签收的运单，请重新选择后再对账', '系统提示')
        } else {
          this.duiZhangData.wayNumber = selectData.length
          this.ids = []
          this.duiZhangData.totalAmount = 0.00
          let payee = selectData[0].payee
          let incomePattern = selectData[0].incomePattern
          let makeTicketYn = selectData[0].makeTicketYn
          let flagB = selectData.every(item => {
            this.ids.push(item.id)
            this.duiZhangData.totalAmount += item.grossRevenue
            return item.payee == payee && item.incomePattern == incomePattern && item.makeTicketYn == makeTicketYn
          })
          this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
          if (flagB) {
            this.duizhangMark = true
            this.duiZhangData.makeTicketYn = selectData[0].makeTicketYn
            this.duiZhangData.settlementPattern = selectData[0].incomePattern
            this.$set(this.duiZhangData, 'ids', this.ids.toString())
          } else {
            this.$alert('请选择同一付款部门、同一结算方式、是否开票的数据', '系统提示')
          }
        }
      }
    },
    // 导出
    daochuFN () {
      if (this.createTimes) {
        this.$set(this.searchFrom, 'createTimeStart', this.createTimes[0])
        this.$set(this.searchFrom, 'createTimeEnd', this.createTimes[1])
      } else {
        this.$set(this.searchFrom, 'createTimeStart', '')
        this.$set(this.searchFrom, 'createTimeEnd', '')
      }
      if (this.actualSignings) {
        this.$set(this.searchFrom, 'actualSigningTimeStart', this.actualSignings[0])
        this.$set(this.searchFrom, 'actualSigningTimeEnd', this.actualSignings[1])
      } else {
        this.$set(this.searchFrom, 'actualSigningTimeStart', '')
        this.$set(this.searchFrom, 'actualSigningTimeEnd', '')
      }
      delete this.searchFrom.pageNo
      delete this.searchFrom.pageSize
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNo = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNo.split(',')
      } else {
        this.$set(this.searchFrom, 'wayNos', '')
        this.searchFrom.wayNoList = null
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportInsideYsWayList',
        this.searchFrom,
        '应收明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
.box{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill,270px);
  grid-auto-flow: row dense;
  .item1{
    grid-row-start: span 2;
  }
  .item2{
    grid-column-start: span 2;
    width: 540px;
  }
}
</style>
